import { EyeParamsType, IEyeParamsOption } from '../../graphql/lenses/models/get-lenses.models';

export const omitEyeParamsByType = (
  eyeParams: IEyeParamsOption[], criterion: EyeParamsType,
) => eyeParams.filter((params) => params.property !== criterion);
